import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import JournalCard from "@/components/feature/JournalCard";
import { articles } from "@/mocks/journal";

const ratios: Array<"tall" | "wide" | "square"> = [
  "wide",
  "tall",
  "square",
  "wide",
  "tall",
  "square",
];

export default function JournalSection() {
  const featured = articles.slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow">The Content Library</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-5 font-heading text-4xl leading-[1.02] text-foreground-950 sm:text-5xl md:text-6xl">
                THE CHEF'S
                <br />
                <span className="italic text-primary-600">TABLE</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:self-end">
            <Reveal delay={200}>
              <p className="font-body text-base leading-relaxed text-foreground-700 md:text-lg">
                Recipes, cooking tips, food stories, travel discoveries and
                behind-the-scenes moments — written the way Eddie cooks: slow,
                honest and full of people.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 columns-1 gap-8 md:columns-2 lg:columns-3">
          {featured.map((article, i) => (
            <div key={article.slug} className="mb-10 break-inside-avoid">
              <Reveal delay={(i % 3) * 90}>
                <JournalCard article={article} ratio={ratios[i % ratios.length]} />
              </Reveal>
            </div>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-8 flex justify-center">
            <Link
              to="/journal"
              className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md border border-foreground-950/25 px-8 py-4 font-label text-[11px] uppercase tracking-label text-foreground-950 transition-all duration-500 hover:bg-foreground-950 hover:text-background-50"
            >
              Enter the Journal
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}